/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/contributorDashboardNavigation.ts.
 */

import type { NavigateFunction } from "react-router-dom";

/** Exported const — CONTRIBUTOR SUBMITTED DATASETS SECTION. */
export const CONTRIBUTOR_SUBMITTED_DATASETS_SECTION = "SubmittedDataset";

/** Exported const — CONTRIBUTOR SUBMITTED DATASET ID PARAM. */
export const CONTRIBUTOR_SUBMITTED_DATASET_ID_PARAM = "submissionId";

/** Exported const — contributor Submitted Datasets Path. */
export const contributorSubmittedDatasetsPath = `/dashboard?section=${CONTRIBUTOR_SUBMITTED_DATASETS_SECTION}`;

/** Exported function — contributor Submitted Dataset Detail Path. */
export function contributorSubmittedDatasetDetailPath(submissionId: string): string {
  const params = new URLSearchParams({
    section: CONTRIBUTOR_SUBMITTED_DATASETS_SECTION,
    [CONTRIBUTOR_SUBMITTED_DATASET_ID_PARAM]: submissionId,
  });
  return `/dashboard?${params.toString()}`;
}

/** Exported function — resolve Contributor Dashboard Section. */
export function resolveContributorDashboardSection(
  search: string,
  state: unknown
): string | null {
  const fromQuery = new URLSearchParams(search).get("section");
  if (fromQuery) return fromQuery;

  const fromState = (state as { activeSection?: string } | null)?.activeSection;
  if (fromState) return fromState;

  return null;
}

/** Exported function — resolve Contributor Dashboard Submission Id. */
export function resolveContributorDashboardSubmissionId(search: string): string | null {
  const id = new URLSearchParams(search).get(CONTRIBUTOR_SUBMITTED_DATASET_ID_PARAM);
  return id?.trim() ? id.trim() : null;
}

/** Navigate back to contributor dashboard → Submitted Datasets list. */
export function navigateToContributorSubmittedDatasets(navigate: NavigateFunction) {
  navigate(
    {
      pathname: "/dashboard",
      search: `?section=${CONTRIBUTOR_SUBMITTED_DATASETS_SECTION}`,
    },
    {
      state: { activeSection: CONTRIBUTOR_SUBMITTED_DATASETS_SECTION },
    }
  );
}

/** Open a submitted dataset detail inside the contributor dashboard. */
export function navigateToContributorSubmittedDatasetDetail(
  navigate: NavigateFunction,
  submissionId: string
) {
  navigate(
    {
      pathname: "/dashboard",
      search: `?section=${CONTRIBUTOR_SUBMITTED_DATASETS_SECTION}&${CONTRIBUTOR_SUBMITTED_DATASET_ID_PARAM}=${encodeURIComponent(submissionId)}`,
    },
    {
      state: { activeSection: CONTRIBUTOR_SUBMITTED_DATASETS_SECTION },
    }
  );
}
